/*
*
* File JS componente Products Slider
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import Swiper from 'swiper';

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './news-slider.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const newsSlider = () => {
    let args = {
        slidesPerView: 'auto',
        spaceBetween: 20,
    };
    const newsSwiperSelector = document.querySelector('.newsSwiper');
    if (newsSwiperSelector) {
        let newsSwiper = new Swiper(document.querySelector('.newsSwiper'), args);
    }
}

export default newsSlider;

//--------------------------------------------------------------------//